"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isActiveServer = exports.initSocialProviderConfig = exports.initSocialIdentityProviderStatus = exports.initSocialIdentityProvider = exports.getRedirectURL = exports.getIDFromType = void 0;
var _uuid = require("uuid");
var _globalStates = require("../../globalstates/globalStates");
var getRedirectURL = exports.getRedirectURL = function getRedirectURL(accessURL, alias) {
  return "".concat(accessURL, "/auth/realms/userful/broker/").concat(alias, "/endpoint");
};
var initSocialIdentityProviderStatus = exports.initSocialIdentityProviderStatus = function initSocialIdentityProviderStatus(accessURL) {
  return {
    provider: initSocialIdentityProvider(accessURL),
    error: false,
    errorKey: "NONE",
    errorMessage: ""
  };
};
var initSocialIdentityProvider = exports.initSocialIdentityProvider = function initSocialIdentityProvider(accessURL) {
  return {
    id: {
      value: ""
    },
    enabled: true,
    type: "MICROSOFT",
    config: [{
      id: {
        value: (0, _uuid.v4)()
      },
      displayName: "",
      syncMode: "FORCE",
      alias: "",
      type: "MICROSOFT",
      clientId: "",
      clientSecret: "",
      tenantId: "",
      redirectURL: getRedirectURL(accessURL, "microsoft")
    }, {
      id: {
        value: (0, _uuid.v4)()
      },
      displayName: "",
      syncMode: "FORCE",
      alias: "",
      type: "MICROSOFT",
      clientId: "",
      clientSecret: "",
      tenantId: "",
      redirectURL: ""
    }]
  };
};
var getIDFromType = exports.getIDFromType = function getIDFromType(type) {
  if (type === "MICROSOFT") return "microsoft";
};
var initSocialProviderConfig = exports.initSocialProviderConfig = function initSocialProviderConfig() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    displayName: "",
    syncMode: "FORCE",
    alias: "",
    type: "MICROSOFT",
    clientId: "",
    clientSecret: "",
    tenantId: "",
    redirectURL: ""
  };
};
var isActiveServer = exports.isActiveServer = function isActiveServer(redirectURL) {
  if (redirectURL === "") {
    return false;
  }
  var activeAccessURL = (0, _globalStates.getGlobalStates)().host;
  return redirectURL.indexOf(activeAccessURL) !== -1;
};